export default "__VITE_ASSET__DiFIqc8C__"